"use client";

import { GlobalContext } from "@/context";
import { useContext, useState } from "react";
import { toast } from "react-toastify";
import PopUpPasserPanier from "../PopUpPasserPanier";

const ButtonAjouterPanier = ({ data }) => {
  const { setPanierData } = useContext(GlobalContext);
  const [showPopUpPasserPanier, setShowPopUpPasserPanier] = useState(false);

  const addProductToPanier = (data) => {
    const panierData = JSON.parse(localStorage.getItem("panier")) || [];
    const panierArray = panierData.find((el) => el._id == data._id)
      ? panierData.map((el) =>
          el._id == data._id ? { ...el, qt: el.qt + 1 } : el
        )
      : [...panierData, { ...data, qt: 1 }];
    localStorage.setItem("panier", JSON.stringify(panierArray));
    setPanierData(panierArray);
    toast.success("Produit ajouté au panier !");
    setShowPopUpPasserPanier(true);
  };
  return (
    <>
      <button
        className="uppercase text-base bg-[#CC0001] text-[#FFFFFF] rounded-[20px] px-3 py-3 font-medium"
        onClick={() => {
          addProductToPanier(data);
        }}
      >
        Ajouter au panier
      </button>
      {showPopUpPasserPanier ? (
        <PopUpPasserPanier
          showPopUpPasserPanier={showPopUpPasserPanier}
          setShowPopUpPasserPanier={setShowPopUpPasserPanier}
        />
      ) : null}
    </>
  );
};

export default ButtonAjouterPanier;
